// TODO Handle states because right now we show a lot of lines for a 2 step process.

import { getHTTPUrlFromS3Path } from "./outputs";

export const scanStates: ScanStatusType[] = [
  { index: 0, status: "INITIALIZING", label: "Initializing" },
  { index: 1, status: "CAMERA_ALIGNMENT", label: "Calibrating cameras" },
  {
    index: 2,
    status: "DENSE_RECONSTRUCTION",
    label: "Running dense reconstruction",
  },
  { index: 3, status: "TEXTURING", label: "Texturing" },
  { index: 4, status: "SEGMENTATION", label: "Segmenting Dense Cloud" },
  { index: 5, status: "GENERATING_RASTERS", label: "Generating rasters" },
  { index: 6, status: "GENERATING_VIDEO_TOUR", label: "Generating video tour" },
];

export const getScanStaus = (status: string) => {
  const fetchedStatus = scanStates.find((state) => state.status === status);
  return fetchedStatus;
};

export const getTotalStates = (outputs: OutputType[]) => {
  const totalStates = scanStates.filter((state) => {
    if (
      state.index == 4 &&
      !outputs.includes("BINSEG") &&
      !outputs.includes("FULLSEG")
    ) {
      return false;
    }
    if (
      state.index == 5 &&
      !outputs.includes("DEM") &&
      !outputs.includes("DTM") &&
      !outputs.includes("ORTHO")
    ) {
      return false;
    }
    return true;
  });

  return totalStates;
};

/**
 * Returns the HTTP URL for a scan output
 * @param scanId The ID of the scan
 * @param outputType The type of output - only accepts 'pointcloud' or 'virtualtour'
 * @returns The HTTP URL for the specified scan output
 */
export const getScanOutputHTTPURL = (scanId: string, outputType: 'pointcloud' | 'virtualtour') => {

  const outputPaths = {
    pointcloud: "pointcloud/",
    virtualtour: "virtualtour/vtour/",
  }

  return getHTTPUrlFromS3Path(`s3://bucketname/${scanId}/${outputPaths[outputType]}`);
};